import { render, staticRenderFns } from "./DialogProjectManagerReview.vue?vue&type=template&id=551ec431"
import script from "./DialogProjectManagerReview.vue?vue&type=script&lang=js"
export * from "./DialogProjectManagerReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports